import { Box, Button, Typography } from "@mui/material";
import { lazy, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MyDivider from "src/components/layout/MyDivider";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";
import PropTypes from "prop-types";

const AsiakasSelectorSearch = lazy(() =>
  import("src/components/asiakas/AsiakasSelectorSearch/AsiakasSelectorSearch")
);
const EditAsiakas = lazy(() => import("src/components/asiakas/edit/EditAsiakas"));

export default function AddrAsiakas({ asiakas }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!asiakas) return;
    if (asiakas && !isOpen) setIsOpen(true);
  }, [asiakas]);

  if (!asiakas) return <ProgressCirc />;

  const handleClose = async () => {
    navigate("/");
    setIsOpen(false);
  };
  const handleOpen = () => setIsOpen(true);
  const doSetSelectedAsiakasId = async (asiakasId) => navigate("/asiakas/" + asiakasId);

  return (
    <div className="appWrapper">
      <LazyLoader>
        <EditAsiakas
          key={asiakas.asiakasId}
          isOpen={isOpen}
          onCancel={handleClose}
          onSave={handleClose}
          asiakasId={asiakas.asiakasId}
          fullScreen={true}
        />
        <Box className="center" style={{ height: "70vh" }}>
          <div className="center flexCol" style={{ gap: 24 }}>
            <Typography variant="h5" color="primary">
              ASIAKAS
            </Typography>
            <MyDivider />
            {asiakas && (
              <Button
                variant="contained"
                onClick={handleOpen}
                fullWidth
                sx={{ width: "400px", height: "50px" }}>
                AVAA ASIAKAS <br /> {asiakas.asiakasNimi}
              </Button>
            )}
            <LazyLoader>
              <AsiakasSelectorSearch
                setAsiakasId={doSetSelectedAsiakasId}
                defaultAsiakasId={asiakas.asiakasId}
                showEditButton={false}
                shrinkLabel
              />
            </LazyLoader>
            <Button
              variant="contained"
              onClick={() => navigate("/")}
              fullWidth
              sx={{ width: "400px", height: "50px" }}>
              ETUSIVULLE
            </Button>
          </div>
        </Box>
      </LazyLoader>
    </div>
  );
}

AddrAsiakas.propTypes = {
  asiakas: PropTypes.object,
};
